import { api } from "@/constants"
import { getAuthHeader, serializeQueryParams } from "@/util"
import baseURL from "@/service/api"

const invoiceGenerator = {
  customers: (params) => {
    const url = api.invoiceGenerator.customers + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  createCustomer: (payloads) => {
    const url = api.invoiceGenerator.customers
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  updateCustomer: (customerId, payloads) => {
    const url = api.invoiceGenerator.customerDetail(customerId)
    return baseURL.put(url, payloads, { headers: getAuthHeader() })
  },
  deleteCustomer: (customerId) => {
    const url = api.invoiceGenerator.customerDetail(customerId)
    return baseURL.delete(url, { headers: getAuthHeader() })
  },

  customerPrices: (params) => {
    const url =
      api.invoiceGenerator.customerPrices + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  customerPriceOptions: (params) => {
    const url =
      api.invoiceGenerator.customerPriceOptions + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  customerPriceDestinations: (params) => {
    const url =
      api.invoiceGenerator.customerPriceDestinations +
      serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  createCustomerPrice: (payloads) => {
    const url = api.invoiceGenerator.customerPrices
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  updateCustomerPrice: (priceId, payloads) => {
    const url = api.invoiceGenerator.customerPriceDetail(priceId)
    return baseURL.put(url, payloads, { headers: getAuthHeader() })
  },
  deleteCustomerPrice: (priceId) => {
    const url = api.invoiceGenerator.customerPriceDetail(priceId)
    return baseURL.delete(url, { headers: getAuthHeader() })
  },

  resi: (params) => {
    const url = api.invoiceGenerator.resi + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  createResi: (payloads) => {
    const url = api.invoiceGenerator.resi
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  resiDetail: (resiId) => {
    const url = api.invoiceGenerator.resiDetail(resiId)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  updateResi: (resiId, payloads) => {
    const url = api.invoiceGenerator.resiDetail(resiId)
    return baseURL.put(url, payloads, { headers: getAuthHeader() })
  },
  deleteResi: (resiId) => {
    const url = api.invoiceGenerator.resiDetail(resiId)
    return baseURL.delete(url, { headers: getAuthHeader() })
  },

  resiPackages: (resiId, params) => {
    const url =
      api.invoiceGenerator.resiPackages(resiId) + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  createPackage: (resiId, payloads) => {
    const url = api.invoiceGenerator.resiPackages(resiId)
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  updatePackage: (packageId, payloads) => {
    const url = api.invoiceGenerator.packageDetail(packageId)
    return baseURL.put(url, payloads, { headers: getAuthHeader() })
  },
  deletePackage: (packageId) => {
    const url = api.invoiceGenerator.packageDetail(packageId)
    return baseURL.delete(url, { headers: getAuthHeader() })
  },

  invoices: (params) => {
    const url = api.invoiceGenerator.invoices + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  createInvoice: (payloads) => {
    const url = api.invoiceGenerator.invoices
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  invoiceDetail: (invoiceId) => {
    const url = api.invoiceGenerator.invoiceDetail(invoiceId)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  deleteInvoice: (invoiceId) => {
    const url = api.invoiceGenerator.invoiceDetail(invoiceId)
    return baseURL.delete(url, { headers: getAuthHeader() })
  },
  invoicePdf: (invoiceId) => {
    const url = api.invoiceGenerator.invoicePdf(invoiceId)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  invoicePdfBlob: (invoiceId) => {
    const url = api.invoiceGenerator.invoicePdf(invoiceId)
    return baseURL.get(url, {
      headers: getAuthHeader(),
      responseType: "blob"
    })
  }
}

export default invoiceGenerator
